.app {
  display: flex;
  flex-wrap: wrap;
}

.info-col {
  display: flex;
  flex-direction: column;
}

.board {
  height: 100vmin;
  width: 100vmin;
}

.board .cell {
  fill: #eeeeee;
}

.board .cell:hover {
  fill: #cccccc;
}

.board .cell polygon {
  stroke: #7c37dc;
}

.board .cell.possible {
  fill: #d1fec8;
}

.board .cell.possible:hover {
  fill: #10b0d0;
}

.board .cell.highlighted {
  fill: #fffe9f;
}

.board .cell.claimed {
  fill: #555555;
}

.board .fish {
  fill: #888888;
}

.penguin {
  fill-opacity: 1;
  stroke: none;
}

.penguin.beak {
  fill: #fb8b00;
}

.penguin.eyes {
  fill: #ffffff;
}

.penguin.foot {
  fill: #fb8b00;
}

.human.penguin {
  color: blue;
  fill: blue;
}

.bot.penguin {
  color: red;
  fill: red;
}

.info-col progress {
  width: 100%;
}

.info-col .win-chance {
  display: flex;
  flex-direction: column;
}

.bot-controls {
  display: flex;
  gap: 0.5rem;
  margin-top: 1rem;
}

.bot-controls button {
  padding: 0.5rem 1rem;
}
